import React from 'react';
import SpaceDashboardOutlinedIcon from '@mui/icons-material/SpaceDashboardOutlined';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';
import GradeOutlinedIcon from '@mui/icons-material/GradeOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import DynamicFeedOutlinedIcon from '@mui/icons-material/DynamicFeedOutlined';
import HealingOutlinedIcon from '@mui/icons-material/HealingOutlined';
import BackupOutlinedIcon from '@mui/icons-material/BackupOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import {
  FACULTY_REVIEWS_LABS_MATCH,
  FACULTY_REVIEWS_PROJECTS_MATCH,
  FACULTY_WORKSPACE_BATCHES_MATCH,
  // STUDENT_ASSIGNMENTS_LABS_MATCH,
  STUDENT_CODING_ASSIGNMENTS_MATCH,
  // STUDENT_LAB_RESULTS_MATCH,
  STUDENT_CODING,
  STUDENT_PROGRESS_MATCH,
} from './isActiveRoute';
import {
  FACULTY_ANALYTICS_PRIMARY_NAV,
  analyticsPath,
  platformAnalyticsPath,
} from '../../constants/codingAnalytics';
import { isAdminSyncOpsUiEnabled } from '../../config/adminSyncOpsFlags';
import { isDiaryTransferUiEnabled } from '../../config/diaryPortabilityFlags';
import { isProblemIntelligenceReadUiEnabled } from '../../config/problemIntelligenceFlags';
import { isAssessmentOrchestrationUiEnabled } from '../../config/assessmentFlags';
import { isReportingIntelligenceUiEnabled } from '../../config/reportingIntelligenceFlags';
import { RI_BASE_ADMIN, RI_BASE_FACULTY } from '../../constants/reportingIntelligence';
import { FACULTY_WORKSPACE_NAV } from '../../constants/facultyWorkspace';
import {
  FACULTY_ACTIVITY_FEED_PATH,
  FACULTY_ASSIGNMENTS_PATH,
  FACULTY_BATCHES_PATH,
  FACULTY_DASHBOARD_PATH,
  FACULTY_DIARY_PATH,
  FACULTY_INTERVENTIONS_PATH,
  FACULTY_LAB_REVIEWS_PATH,
  FACULTY_LESSON_PLANS_PATH,
  FACULTY_TEACHING_REPORTS_PATH,
  FACULTY_PROJECT_REVIEWS_PATH,
  FACULTY_STUDENTS_PATH,
  FACULTY_WORKSPACE_OVERVIEW_PATH,
} from '../../constants/facultyNav';
import { filterNavigationSections } from './filterNavigationByCapability';
import {
  ADMIN_PROBLEM_LIBRARY_PATH,
  ADMIN_PROBLEM_LIBRARY_ANALYTICS_PATH,
  FACULTY_PROBLEM_LIBRARY_PATH,
  FACULTY_PROBLEM_LIBRARY_ANALYTICS_PATH,
} from '../../constants/problemLibrary';
import { FACULTY_ASSESSMENTS_PATH } from '../../constants/facultyAssessments';
import { STUDENT_ASSESSMENTS_PATH } from '../../constants/studentAssessments';
import { ADMIN_PROBLEM_INTELLIGENCE_OPS_PATH } from '../../constants/problemIntelligenceOps';
// RBAC Migration: Removed isCbcFaculty import - use effectiveCapabilities instead
import { getCoordinatorPlacementNavMeta, getStudentPlacementNavMeta, getPlacementNavSectionTitle } from '../../utils/placementNav';

/** @typedef {{ id: string, label: string, path?: string, matchPath?: string, icon: React.ReactNode, action?: 'logout' }} ResolvedNavItem */
/** @typedef {{ id: string, title?: string, initiallyExpanded?: boolean, collapsible?: boolean, items: ResolvedNavItem[] }} ResolvedNavSection */

const icon = {
  spaceDashboard: <SpaceDashboardOutlinedIcon fontSize="small" />,
  analytics: <AnalyticsOutlinedIcon fontSize="small" />,
  policy: <PolicyOutlinedIcon fontSize="small" />,
  healing: <HealingOutlinedIcon fontSize="small" />,
  backup: <BackupOutlinedIcon fontSize="small" />,
  build: <BuildOutlinedIcon fontSize="small" />,
  gavel: <GavelOutlinedIcon fontSize="small" />,
  hub: <HubOutlinedIcon fontSize="small" />,
  dashboard: <DashboardOutlinedIcon fontSize="small" />,
  school: <SchoolOutlinedIcon fontSize="small" />,
  assignment: <AssignmentOutlinedIcon fontSize="small" />,
  tune: <TuneOutlinedIcon fontSize="small" />,
  toggleOn: <ToggleOnOutlinedIcon fontSize="small" />,
  people: <PeopleOutlineOutlinedIcon fontSize="small" />,
  lock: <LockOutlinedIcon fontSize="small" />,
  listAlt: <ListAltOutlinedIcon fontSize="small" />,
  quiz: <QuizOutlinedIcon fontSize="small" />,
  grade: <GradeOutlinedIcon fontSize="small" />,
  profile: <PersonOutlineIcon fontSize="small" />,
  menuBook: <MenuBookOutlinedIcon fontSize="small" />,
  science: <ScienceOutlinedIcon fontSize="small" />,
  accountTree: <AccountTreeOutlinedIcon fontSize="small" />,
  folder: <FolderOutlinedIcon fontSize="small" />,
  assessment: <AssessmentOutlinedIcon fontSize="small" />,
  activityFeed: <DynamicFeedOutlinedIcon fontSize="small" />,
  placement: <WorkOutlineOutlinedIcon fontSize="small" />,
  diary: <EventNoteOutlinedIcon fontSize="small" />,
  lessonPlan: <CalendarMonthOutlinedIcon fontSize="small" />,
  swapHoriz: <SwapHorizOutlinedIcon fontSize="small" />,
};

/** Top or bottom row(s) without a group header (aligned with dashboard nav density). */
function flatNavSection(id, items) {
  return /** @type {ResolvedNavSection} */ ({
    id,
    collapsible: false,
    items,
  });
}

function resolvePlacementNavItems(metaItems) {
  return metaItems.map(({ iconKey, ...item }) => ({
    ...item,
    icon: icon[iconKey] ?? icon.placement,
  }));
}

function placementNavSection(user, effectiveCapabilities = []) {
  const items = resolvePlacementNavItems(getCoordinatorPlacementNavMeta(user, effectiveCapabilities));
  if (items.length === 0) return null;
  return {
    id: 'placement',
    title: getPlacementNavSectionTitle(user),
    initiallyExpanded: true,
    items,
  };
}

function studentPlacementNavSection() {
  return {
    id: 'placement',
    title: getPlacementNavSectionTitle({ role: 'student' }),
    initiallyExpanded: true,
    items: resolvePlacementNavItems(getStudentPlacementNavMeta()),
  };
}

const FACULTY_PROFILE_PATH = '/faculty/profile';

/**
 * Administration — the setup surfaces, not the day-to-day ones.
 *
 * Batches moved in from the old Coding Workspace group: a batch is configured
 * once a term and then lived with, which is administration, not delivery. Its
 * path and guard are untouched.
 *
 * Shared teaching surfaces: same paths for `faculty` and `cbcfaculty`
 * (see {@link RequireFacultyTeaching}).
 */
function facultyAdministrationNavItems() {
  return [
    workspaceNavItem('batches'),
    { id: 'courses', label: 'Courses', path: '/faculty/courses', icon: icon.school },
    { id: 'questions', label: 'Question Bank', path: '/faculty/questions', icon: icon.quiz },
    // Not in the requested list, but kept visible: dropping it from the sidebar
    // would strand a live page with no entry point.
    { id: 'labs', label: 'Lab Internals', path: '/faculty/lab-internals', icon: icon.science },
  ];
}

/**
 * Teaching — everything about delivering a course and assessing it: the diary,
 * the plan, the work set, and the assessment of that work.
 *
 * Assignments and Assessments moved in from the old Coding Workspace group;
 * Teaching Reports moved out to Analytics, where the other reporting lives.
 * Every path is unchanged.
 */
function facultyTeachingNavSection() {
  return {
    id: 'teaching',
    title: 'Teaching',
    initiallyExpanded: true,
    items: [
      {
        id: 'faculty-diary',
        label: 'Faculty Diary',
        // Lands on the dashboard, not the day view: the week overview, search,
        // recent entries and export/import are the orientation surface, and
        // "Open today's diary" is one click from there. `matchPath` keeps the
        // item highlighted across every /faculty/diary/* route.
        path: FACULTY_DIARY_PATH,
        matchPath: FACULTY_DIARY_PATH,
        icon: icon.diary,
      },
      {
        id: 'lesson-plans',
        label: 'Lesson Plans',
        path: FACULTY_LESSON_PLANS_PATH,
        icon: icon.lessonPlan,
      },
      workspaceNavItem('assignments'),
      ...facultyAssessmentsNavItem(),
    ],
  };
}

function facultyReviewsNavItems() {
  return [
    {
      id: 'reviews-labs',
      label: 'Labs',
      path: FACULTY_LAB_REVIEWS_PATH,
      matchPath: FACULTY_REVIEWS_LABS_MATCH,
      icon: icon.science,
    },
    {
      id: 'reviews-projects',
      label: 'Projects',
      path: FACULTY_PROJECT_REVIEWS_PATH,
      matchPath: FACULTY_REVIEWS_PROJECTS_MATCH,
      icon: icon.folder,
    },
  ];
}

const FACULTY_WORKSPACE_NAV_META = {
  overview: {
    path: FACULTY_WORKSPACE_OVERVIEW_PATH,
    matchPath: FACULTY_WORKSPACE_OVERVIEW_PATH,
    icon: icon.spaceDashboard,
  },
  batches: {
    path: FACULTY_BATCHES_PATH,
    matchPath: FACULTY_WORKSPACE_BATCHES_MATCH,
    icon: icon.accountTree,
  },
  assignments: {
    path: FACULTY_ASSIGNMENTS_PATH,
    matchPath: FACULTY_ASSIGNMENTS_PATH,
    icon: icon.assignment,
  },
  interventions: {
    path: FACULTY_INTERVENTIONS_PATH,
    matchPath: FACULTY_INTERVENTIONS_PATH,
    icon: icon.healing,
  },
};

const FACULTY_WORKSPACE_NAV_BY_SEGMENT = new Map(
  FACULTY_WORKSPACE_NAV.map((item) => [item.segment, item]),
);

/** One workspace item — label from {@link FACULTY_WORKSPACE_NAV}, route from {@link FACULTY_WORKSPACE_NAV_META}. */
function workspaceNavItem(segment) {
  const item = FACULTY_WORKSPACE_NAV_BY_SEGMENT.get(segment);
  return {
    id: `cw-${item.id}`,
    label: item.label,
    ...FACULTY_WORKSPACE_NAV_META[segment],
  };
}

/** Reporting & Intelligence — gated by client flag (server still 404s when off). */
function reportingIntelligenceNavItem(basePath) {
  if (!isReportingIntelligenceUiEnabled()) return [];
  return [
    {
      id: 'reporting-intelligence',
      label: 'Reports',
      path: basePath,
      matchPath: basePath,
      icon: icon.assessment,
    },
  ];
}

/**
 * Analytics order as faculty read it: how students are doing, then how the work
 * they were set is doing, then the cohort overall, then teaching effectiveness,
 * then the report surfaces.
 *
 * Declared here rather than by reordering {@link FACULTY_ANALYTICS_PRIMARY_NAV},
 * which also drives the analytics page's own tabs — nav order is a sidebar
 * concern and must not move those.
 */
const FACULTY_ANALYTICS_NAV_ORDER = Object.freeze([
  'students',
  'batches',
  'overall',
  'effectiveness',
  'platforms',
]);

/**
 * Each analytics entry borrows the icon of the thing it measures, so the
 * section reads as a set rather than five variations on a bar chart — and so
 * "Assignment Analytics" stops wearing the Batches icon.
 */
const ANALYTICS_ICON_BY_ID = Object.freeze({
  students: 'people',
  batches: 'assignment',
  overall: 'analytics',
  effectiveness: 'grade',
  platforms: 'hub',
});

/** Faculty-centric analytics — student, batch, and platform intelligence. */
function facultyAnalyticsNavItems() {
  const byId = new Map(FACULTY_ANALYTICS_PRIMARY_NAV.map((item) => [item.id, item]));
  const ordered = FACULTY_ANALYTICS_NAV_ORDER.map((id) => byId.get(id)).filter(Boolean);

  return [
    ...ordered.map((item) => ({
      id: `an-${item.id}`,
      label: item.label,
      path:
        item.segment === 'platforms'
          ? platformAnalyticsPath('comparison')
          : analyticsPath(item.segment),
      matchPath:
        item.segment === 'platforms'
          ? '/faculty/analytics/platforms'
          : analyticsPath(item.segment),
      icon: icon[ANALYTICS_ICON_BY_ID[item.id]] ?? icon.assessment,
    })),
    {
      id: 'teaching-reports',
      label: 'Teaching Reports',
      path: FACULTY_TEACHING_REPORTS_PATH,
      icon: icon.listAlt,
    },
    ...reportingIntelligenceNavItem(RI_BASE_FACULTY),
  ];
}

/** Shared Coding Workspace + Analytics groups for faculty with coding access. */
function facultyProblemLibraryNavItem() {
  if (!isProblemIntelligenceReadUiEnabled()) return [];
  return [
    {
      id: 'problem-library',
      label: 'Problem Library',
      path: FACULTY_PROBLEM_LIBRARY_PATH,
      matchPath: FACULTY_PROBLEM_LIBRARY_PATH,
      icon: icon.menuBook,
    },
    {
      id: 'problem-library-analytics',
      label: 'Problem Analytics',
      path: FACULTY_PROBLEM_LIBRARY_ANALYTICS_PATH,
      matchPath: FACULTY_PROBLEM_LIBRARY_ANALYTICS_PATH,
      icon: icon.analytics,
    },
  ];
}

/** Assessment Orchestration list — gated by client flag (server still 404s when off). */
function facultyAssessmentsNavItem() {
  if (!isAssessmentOrchestrationUiEnabled()) return [];
  return [
    {
      id: 'faculty-assessments',
      label: 'Assessments',
      path: FACULTY_ASSESSMENTS_PATH,
      matchPath: FACULTY_ASSESSMENTS_PATH,
      icon: icon.assessment,
    },
  ];
}

/**
 * Students — who the teaching lands on: the roster, the coaching that follows
 * from it, and the live signal feeding both.
 *
 * These were top-level items before the first IA pass and inside Coding
 * Workspace after it. They are now their own section, which is what they always
 * were about. Paths and guards are unchanged, and Activity Feed keeps its
 * existing CBC-only visibility.
 */
function facultyStudentsNavSection({ includeActivityFeed = false } = {}) {
  return {
    id: 'students',
    title: 'Students',
    initiallyExpanded: true,
    items: [
      { id: 'cw-students', label: 'Students', path: FACULTY_STUDENTS_PATH, icon: icon.people },
      workspaceNavItem('interventions'),
      ...(includeActivityFeed
        ? [
            {
              id: 'cw-activity-feed',
              label: 'Activity Feed',
              path: FACULTY_ACTIVITY_FEED_PATH,
              icon: icon.activityFeed,
            },
          ]
        : []),
    ],
  };
}

/**
 * Problem Intelligence — problem discovery, reuse and effectiveness, promoted
 * to a first-class section rather than two entries buried in a workspace list.
 *
 * Returns null when the read flag is off, so an empty section never renders.
 */
function facultyProblemIntelligenceNavSection() {
  const items = facultyProblemLibraryNavItem();
  if (items.length === 0) return null;
  return {
    id: 'problem-intelligence',
    title: 'Problem Intelligence',
    initiallyExpanded: false,
    items,
  };
}

/**
 * Analytics — cross-cutting performance and reporting.
 *
 * Ordered student-first: progress, then the work, then the cohort, then the
 * teaching. Teaching Reports moved here from Teaching; Platform Analytics stays
 * visible even though it is outside the requested list, because removing a live
 * page's only entry point is not an IA improvement.
 */
function facultyAnalyticsNavSection() {
  return {
    id: 'analytics',
    title: 'Analytics',
    initiallyExpanded: false,
    items: facultyAnalyticsNavItems(),
  };
}

/**
 * Dashboard — the two landing surfaces, side by side and ungrouped.
 *
 * Coding Overview came from the dissolved Coding Workspace section. It is a
 * real dashboard (batch quick-access, weekly coding KPIs, operational KPIs,
 * quick actions), so it belongs beside Dashboard rather than being dropped from
 * navigation. Labelled "Coding Overview" because a bare "Overview" sitting
 * under "Dashboard" says nothing about which is which; the route is unchanged.
 *
 * @param {string} dashboardItemId keeps the existing per-variant item id
 */
function facultyDashboardNavSection(dashboardItemId) {
  return flatNavSection('dashboard', [
    { id: dashboardItemId, label: 'Dashboard', path: FACULTY_DASHBOARD_PATH, icon: icon.dashboard },
    { ...workspaceNavItem('overview'), label: 'Coding Overview' },
  ]);
}

/**
 * The middle of the faculty sidebar, shared by both variants: who the teaching
 * lands on, the problem catalogue behind it, and the numbers over it.
 */
function facultyCoreNavSections(options) {
  const problemIntelligence = facultyProblemIntelligenceNavSection();
  return [
    facultyStudentsNavSection(options),
    ...(problemIntelligence ? [problemIntelligence] : []),
    facultyAnalyticsNavSection(),
  ];
}

function facultyProfileNavSection() {
  return flatNavSection('profile', [
    { id: 'profile-link', label: 'Profile', path: FACULTY_PROFILE_PATH, icon: icon.profile },
  ]);
}

/**
 * Coding-first navigation for CBC faculty.
 *
 * Top-level order: Dashboard → Teaching → Students → Problem Intelligence →
 * Analytics → Placements → Administration → Reviews (+ Profile, appended by
 * {@link getFacultyNavSections}). CBC additionally sees Activity Feed under
 * Students.
 */
function cbcFacultyPrimaryNavSections(user) {
  const placementSection = placementNavSection(user);
  return [
    facultyDashboardNavSection('cbc-dashboard'),
    facultyTeachingNavSection(),
    ...facultyCoreNavSections({ includeActivityFeed: true }),
    ...(placementSection ? [placementSection] : []),
  ];
}

/**
 * Admin nav: system control & monitoring only (no faculty teaching workflows).
 * Placeholder routes back `UnderConstruction` until dedicated admin views ship.
 */
export function getAdminNavSections(ctx = {}) {
  const user = ctx.user ?? { role: 'admin' };
  const profilePath = '/admin/profile';
  const placementSection = placementNavSection(user);

  return [
    flatNavSection('dashboard', [
      { id: 'admin-dashboard', label: 'Dashboard', path: '/admin/overview', icon: icon.dashboard },
    ]),
    {
      id: 'organization',
      title: 'Organization',
      initiallyExpanded: true,
      items: [
        {
          id: 'org-batches',
          label: 'Departments & batches',
          path: '/admin/coding-tracker',
          icon: icon.accountTree,
        },
        {
          id: 'org-users',
          label: 'Users (students & faculty)',
          path: '/admin/users',
          icon: icon.people,
        },
      ],
    },
    {
      id: 'academic-oversight',
      title: 'Academic oversight',
      initiallyExpanded: true,
      items: [
        {
          id: 'ac-analytics',
          label: 'Department analytics',
          path: '/admin/analytics',
          icon: icon.assessment,
        },
        ...reportingIntelligenceNavItem(RI_BASE_ADMIN),
        {
          id: 'ac-teaching-reports',
          label: 'Teaching Reports',
          path: '/admin/teaching-reports',
          icon: icon.diary,
        },
        ...(isDiaryTransferUiEnabled()
          ? [
              {
                id: 'ac-diary-transfer',
                label: 'Faculty Diary Tools',
                path: '/admin/faculty-diary/transfer',
                icon: icon.swapHoriz,
              },
            ]
          : []),
        {
          id: 'ac-courses',
          label: 'Courses overview',
          path: '/admin/courses-overview',
          icon: icon.menuBook,
        },
        {
          id: 'ac-labs',
          label: 'Lab activity',
          path: '/admin/lab-activity',
          icon: icon.science,
        },
      ],
    },
    {
      id: 'coding-insights',
      title: 'Coding insights',
      initiallyExpanded: true,
      items: [
        {
          id: 'ci-platform',
          label: 'Platform health',
          path: '/admin/platform-health',
          icon: icon.analytics,
        },
        ...(isProblemIntelligenceReadUiEnabled()
          ? [
              {
                id: 'ci-problem-library',
                label: 'Problem Library',
                path: ADMIN_PROBLEM_LIBRARY_PATH,
                matchPath: ADMIN_PROBLEM_LIBRARY_PATH,
                icon: icon.menuBook,
              },
              {
                id: 'ci-problem-library-analytics',
                label: 'Problem Analytics',
                path: ADMIN_PROBLEM_LIBRARY_ANALYTICS_PATH,
                matchPath: ADMIN_PROBLEM_LIBRARY_ANALYTICS_PATH,
                icon: icon.analytics,
              },
            ]
          : []),
        ...(isAdminSyncOpsUiEnabled()
          ? [
              {
                id: 'ci-sync-ops',
                label: 'Sync Operations',
                path: '/admin/sync-operations',
                icon: icon.healing,
              },
            ]
          : []),
        {
          id: 'ci-plagiarism',
          label: 'Plagiarism insights',
          path: '/admin/plagiarism-analytics',
          icon: icon.policy,
        },
        {
          id: 'ci-handle-claims',
          label: 'Platform Handle Claims',
          path: '/admin/platform-handle-claims',
          icon: icon.gavel,
        },
      ],
    },
    ...(placementSection ? [placementSection] : []),
    {
      id: 'system',
      title: 'System',
      initiallyExpanded: false,
      items: [
        { id: 'sys-settings', label: 'Settings', path: '/admin/coding-platforms', icon: icon.tune },
        { id: 'sys-integrity', label: 'Data integrity', path: '/admin/data-integrity', icon: icon.policy },
        { id: 'sys-recovery', label: 'System recovery', path: '/admin/student-recovery', icon: icon.healing },
        { id: 'sys-recovery-center', label: 'Recovery Center', path: '/admin/recovery-center', icon: icon.build },
        { id: 'sys-problem-intelligence', label: 'Problem Intelligence', path: ADMIN_PROBLEM_INTELLIGENCE_OPS_PATH, icon: icon.hub },
        { id: 'sys-backups', label: 'Backups', path: '/admin/backups', icon: icon.backup },
        { id: 'sys-features', label: 'Feature management', path: '/admin/features', icon: icon.toggleOn },
        { id: 'sys-monitoring-rules', label: 'Monitoring rules', path: '/admin/monitoring-rules', icon: icon.policy },
        { id: 'sys-assessment-anomalies', label: 'Assessment anomalies', path: '/admin/assessment-anomalies', icon: icon.policy },
        { id: 'sys-monitoring-alarms', label: 'Monitoring alarms', path: '/admin/monitoring-alarms', icon: icon.policy },
        { id: 'sys-monitoring-purge', label: 'Monitoring purge', path: '/admin/monitoring-purge', icon: icon.policy },
        { id: 'sys-access', label: 'Access control', path: '/admin/access-control', icon: icon.lock },
      ],
    },
    flatNavSection('profile', [
      { id: 'admin-profile', label: 'Profile', path: profilePath, icon: icon.profile },
    ]),
  ];
}

/** Administration + Reviews + Profile — the same tail for every faculty variant. */
function facultyNavTailSections() {
  return [
    {
      id: 'administration',
      title: 'Administration',
      initiallyExpanded: false,
      items: facultyAdministrationNavItems(),
    },
    {
      id: 'reviews',
      title: 'Reviews',
      initiallyExpanded: false,
      items: facultyReviewsNavItems(),
    },
    facultyProfileNavSection(),
  ];
}

/**
 * Faculty sidebar: teaching vs CBC via capabilities.
 *
 * RBAC Migration: Changed from role-based isCbcFaculty to capability-based check.
 * Checks for MANAGE_BATCHES capability to determine if CBC nav structure should be shown.
 *
 * Top-level IA: Dashboard → Teaching → Students → Problem Intelligence →
 * Analytics → Placements → Administration → Reviews → Profile.
 *
 * The Coding Workspace group is gone; its contents were rehomed by what they
 * are for — Assignments and Assessments to Teaching, Batches to Administration,
 * Students and Interventions to their own section, the problem catalogue to
 * Problem Intelligence, and Overview beside Dashboard. Routes, permissions and
 * feature-flag gates are untouched; only grouping and section order change.
 *
 * @param {{ user?: { role?: string, subtype?: string, facultyType?: string }, effectiveCapabilities?: string[] }} ctx
 */
export function getFacultyNavSections(ctx) {
  const user = ctx.user;
  const effectiveCapabilities = ctx?.effectiveCapabilities || [];

  // Check for MANAGE_BATCHES capability (coding_programme_coordinator responsibility)
  // Fallback to cbcfaculty role check for backward compatibility (tests, legacy sessions)
  const hasCodingCapability = (Array.isArray(effectiveCapabilities) && effectiveCapabilities.includes('MANAGE_BATCHES'))
    || user.role === 'cbcfaculty';

  if (hasCodingCapability) {
    return [...cbcFacultyPrimaryNavSections(user), ...facultyNavTailSections()];
  }

  const facultyPlacementSection = placementNavSection(user, effectiveCapabilities);

  return [
    facultyDashboardNavSection('dash'),
    facultyTeachingNavSection(),
    ...facultyCoreNavSections(),
    ...(facultyPlacementSection ? [facultyPlacementSection] : []),
    ...facultyNavTailSections(),
  ];
}

/**
 * Student nav: action-first, minimal groups.
 */
export function getStudentNavSections(eligibility = {}) {
  const profilePath = '/student/profile';
  // Year gating (services/studentEligibilityService). Default to visible so a
  // caller that has not yet wired eligibility keeps the pre-gating navigation.
  const showProjects = eligibility.projects !== false;
  const showPlacement = eligibility.placementHub !== false;

  return [
    flatNavSection('dashboard', [
      { id: 'home', label: 'Dashboard', path: '/student/home', icon: icon.dashboard },
      ...(showProjects
        ? [{ id: 'projects', label: 'My Projects', path: '/student/projects', icon: icon.folder }]
        : []),
    ]),
    {
      id: 'coding',
      title: 'Coding',
      initiallyExpanded: true,
      items: [
        { id: 'coding-dashboard', label: 'Coding Dashboard', path: '/student/coding', matchPath: STUDENT_CODING, icon: icon.dashboard },
        { id: 'coding-progress', label: 'Coding Progress', path: '/student/progress', matchPath: STUDENT_PROGRESS_MATCH, icon: icon.analytics },
      ],
    },

    {
      id: 'my-learning',
      title: 'My learning',
      initiallyExpanded: true,
      items: [
        { id: 'courses', label: 'My courses', path: '/student/courses', icon: icon.menuBook },
        {
          id: 'assignments',
          label: 'Assignments',
          path: '/student/assignments',
          matchPath: STUDENT_CODING_ASSIGNMENTS_MATCH,
          icon: icon.assignment,
        },
        ...(isAssessmentOrchestrationUiEnabled()
          ? [
              {
                id: 'assessments',
                label: 'Assessments',
                path: STUDENT_ASSESSMENTS_PATH,
                matchPath: STUDENT_ASSESSMENTS_PATH,
                icon: icon.assessment,
              },
            ]
          : []),
      ],
    },
    
    // flatNavSection('coding', [
    //   {
    //     id: 'coding-dashboard',
    //     label: 'Dashboard',
    //     path: '/student/coding',
    //     matchPath: STUDENT_CODING,
    //     icon: icon.dashboard,
    //   },
    //   {
    //     id: 'coding-progress',
    //     label: 'My Progress',
    //     path: '/student/progress',
    //     matchPath: STUDENT_PROGRESS_MATCH,
    //     icon: icon.analytics,
    //   },
    // ]),
    ...(showPlacement ? [studentPlacementNavSection()] : []),
    flatNavSection('profile', [
      { id: 'profile-link', label: 'Profile', path: profilePath, icon: icon.profile },
    ]),
  ];
}

/**
 * Get faculty navigation sections filtered by effective capabilities.
 *
 * This wrapper applies capability-based visibility filtering to the full faculty nav.
 * Sections with no visible items are removed.
 *
 * @param {{ user?: object, effectiveCapabilities?: string[] }} ctx - User context with capabilities
 * @returns {Array} - Filtered navigation sections
 */
export function getFacultyNavSectionsWithCapabilities(ctx) {
  // Pass effectiveCapabilities to getFacultyNavSections for CBC nav decision
  const sections = getFacultyNavSections(ctx);
  const effectiveCapabilities = ctx?.effectiveCapabilities || [];

  // Apply capability-based filtering
  return filterNavigationSections(sections, effectiveCapabilities);
}

/**
 * Get admin navigation sections filtered by effective capabilities.
 *
 * @param {{ user?: object, effectiveCapabilities?: string[] }} ctx - User context with capabilities
 * @returns {Array} - Filtered navigation sections
 */
export function getAdminNavSectionsWithCapabilities(ctx) {
  const sections = getAdminNavSections(ctx);
  const effectiveCapabilities = ctx?.effectiveCapabilities || [];

  // Apply capability-based filtering
  return filterNavigationSections(sections, effectiveCapabilities);
}

/**
 * Get student navigation sections filtered by effective capabilities.
 *
 * @param {{ eligibility?: object, effectiveCapabilities?: string[] }} ctx - User context with capabilities
 * @returns {Array} - Filtered navigation sections
 */
export function getStudentNavSectionsWithCapabilities(ctx) {
  const sections = getStudentNavSections(ctx?.eligibility);
  const effectiveCapabilities = ctx?.effectiveCapabilities || [];

  // Apply capability-based filtering
  return filterNavigationSections(sections, effectiveCapabilities);
}
